import React from "react";
import teamPic from "./assets/Profile.svg";
import Fade from "react-reveal/Fade";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Typed from "react-typed";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";

const About = () => {
  const theme = useTheme();

  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });
  return (
    <section className="about overflow-hidden py-5">
      <div className="w-100">
        <div
          className="row col-md-11 mx-auto"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div className="col-md-6 img">
            <Fade duration={4000} left>
              <img src={`${teamPic}`} alt="" className="img-fluid" />
            </Fade>
          </div>
          <div className="col-md-6 ps-2">
            <Fade duration={4000} right className="about">
              <Grid
                item
                xs={12}
                md={6}
                alignItems={"left"}
                sx={{
                  width: "100%",
                }}
              >
                <Box
                  data-aos={isMd ? "fade-right" : "fade-up"}
                  paddingLeft={isMd && 2}
                  p={1}
                >
                  <Box marginBottom={2}>
                    <Typography
                      variant="h4"
                      color="text.primary"
                      sx={{
                        fontSize: "1.70rem",
                        display: "grid",
                        color: "#fff",
                        margin: "auto",
                        fontFamily: "Raleway",
                      }}
                    >
                      I am a
                      <Typography
                        color="#ed3d24"
                        component={"span"}
                        variant={"inherit"}
                      >
                        <Typed
                          strings={[
                            "Coding Enthusiastic",
                            "Frontend Developer",
                            "Contributer",
                            "Innovative Thinker",
                          ]}
                          typeSpeed={100}
                          loop={true}
                          style={{ fontWeight: "700" }}
                        />
                      </Typography>
                    </Typography>
                  </Box>
                  <Box marginBottom={3}>
                    <Typography
                      variant="h6"
                      component="p"
                      color="#fff"
                      style={{
                        fontFamily: "Arizona",
                        textAlign: "center",
                        fontSize: "1.1rem",
                        fontWeight: "400",
                      }}
                    >
                      A frontend wizard, pushing boundaries with innovative
                      thinking and seamless user experiences, while fostering
                      collaboration and empowering the developer community.
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Fade>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
